import { Component, effect, input, ViewChild } from '@angular/core';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { ClientCreditTableItem } from 'src/app/services/credits/credits.service';
import { MatCardContent } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CurrencyPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-credit-spending-table',
  templateUrl: './credit-spending-table.component.html',
  styleUrls: ['./credit-spending-table.component.scss'],
  imports: [
    MatCardContent,
    MatProgressSpinner,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    CurrencyPipe,
    TranslateModule,
  ],
})
export class CreditSpendingTableComponent {
  readonly dataSource = new MatTableDataSource<ClientCreditTableItem>();
  readonly displayedColumns = ['amount', 'fee_label', 'product_label'];

  readonly loading = input(false);
  readonly data = input.required<ClientCreditTableItem[]>();

  constructor() {
    effect(() => {
      this.dataSource.data = this.data();
    });
  }

  @ViewChild(MatSort) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
}
